var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTelefon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 26,
    viewBox: "0 0 24 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_478_190",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 26
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 25.3474,
    transform: "matrix(-1 0 0 1 24 0.547363)",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_478_190)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.05 22.9758C4.2 22.9758 6.29583 22.4631 8.3375 21.4376C10.3792 20.4122 12.1875 19.0568 13.7625 17.3715C15.3375 15.6862 16.6042 13.7513 17.5625 11.5666C18.5208 9.38201 19 7.13941 19 4.83886C19 4.51785 18.9 4.25034 18.7 4.03634C18.5 3.82233 18.25 3.71533 17.95 3.71533H13.9C13.6667 3.71533 13.4583 3.79558 13.275 3.95609C13.0917 4.11659 12.9833 4.32168 12.95 4.57135L12.3 8.31644C12.2667 8.56611 12.2708 8.7935 12.3125 8.99858C12.3542 9.20367 12.45 9.38647 12.6 9.54697L15.025 12.1685C14.325 13.4526 13.4458 14.6563 12.3875 15.7799C11.3292 16.9034 10.1667 17.8753 8.9 18.6957L6.55 16.1811C6.4 16.0206 6.20417 15.9002 5.9625 15.82C5.72083 15.7397 5.48333 15.7175 5.25 15.7531L1.8 16.5021C1.56667 16.5556 1.375 16.676 1.225 16.8633C1.075 17.0505 1 17.269 1 17.5187V21.8523C1 22.1733 1.1 22.4408 1.3 22.6548C1.5 22.8688 1.75 22.9758 2.05 22.9758ZM15.975 10.1355L14.325 8.36994L14.75 5.85538H16.975C16.8917 6.58657 16.775 7.30883 16.625 8.02218C16.475 8.73554 16.2583 9.43997 15.975 10.1355ZM7.025 19.7122C6.375 20.0154 5.7125 20.2561 5.0375 20.4345C4.3625 20.6128 3.68333 20.7287 3 20.7822V18.4282L5.35 17.9199L7.025 19.7122Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelefon);
export default __webpack_public_path__ + "static/media/telefon.8e03afefa2c7980973e2f632afcbe7ea.svg";
export { ForwardRef as ReactComponent };